// src/components/ClientsSection.jsx
import React from "react";

export default function ClientsSection({
  bgClass = "grey-bg",
  title = "Shree Swami Samarth PG offers a unique and Welcoming Environment that aims to make Residents Feel at Home.",
  heading = "Shree Swami Samarth PG ( Paying Guest )",
  text = "At Shree Swami Samarth PG, the emphasis is on creating comfortable living spaces.",
  secondaryBtn = {
    label: "Contact Us",
    href: "/contact",
    className: "theme-btn btn-style-five"
  }
}) {
  // WhatsApp contact message
  const whatsappNumber = "919209169761"; // Remove '+' for wa.me
  const whatsappMessage =
    "Thank you for your inquiry! We are reaching out to you to provide any information you may need about our PG. Feel free to ask questions or let us know if you'd like to schedule a visit. We're here to assist you in making the best decision for your accommodation needs. 9209169761 / reservation@swamisamarthpg.com Thank you.";
  const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(whatsappMessage)}`;

  return (
    <>
      {/* Page Title Section */}
      <section
        className="page-title"
        style={{ backgroundImage: "url(images/background/3.jpg)" }}
      >
        <div className="auto-container">
          <h1>Online Payments</h1>
        </div>
      </section>

      {/* Clients Section */}
      <section className={`clients-section ${bgClass}`}>
        <div className="auto-container">
          <div className="title-box">
            <div className="title">{title}</div>
            <h2>{heading}</h2>
            <div className="text">{text}</div>
            <div className="btns-box">
              {/* WhatsApp Book Now Button */}
              <a
                href={whatsappLink}
                className="theme-btn btn-style-four"
                target="_blank"
                rel="noopener noreferrer"
              >
                Book Now
              </a>

              {/* Secondary Button */}
              <a
                href={secondaryBtn.href}
                className={secondaryBtn.className}
              >
                {secondaryBtn.label}
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
